module.exports = __webpack_public_path__ + "static/media/phone_8.1af6c682.png";